import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { mutationDeleteSchedulerPost } from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import ConfirmModal from "module-common/ConfirmModal";

export default graphql(mutationDeleteSchedulerPost)(
  class DeleteButton extends Component {
    static propTypes = { id: PropTypes.number };
    state = { showModal: false };

    render() {
      return [
        <Icon
          key="trash"
          name="recycle-bin"
          onClick={() => this.setState({ showModal: true })}
          {...this.props}
        />,
        this.state.showModal && (
          <ConfirmModal
            key="modal"
            text="Do you want to delete this scheduled post?"
            onCancel={() => this.setState({ showModal: false })}
            onConfirm={this.onConfirm}
          />
        )
      ];
    }

    onConfirm = async () => {
      const { id, refetch, mutate } = this.props;
      try {
        await mutate({
          variables: { SchedulerInputId: id }
        });
        this.setState({ showModal: false });
        ShowNotice("scheduled-post-delete-success");
      } catch (error) {
        ShowNotice("scheduled-post-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-schedule/list/DeleteButtonWithMutation.js